export default __webpack_public_path__ + "static/media/4690@2x.a39eabed.png";